import { useNavigate } from "react-router-dom";
import blogImage from "../../Images/blog-image.png";
import cardImage from "../../Images/cards.png";
import jordanImage from "../../Images/jordan.png";
import { COMPANY_LOGO } from "../../Components/Report/constants";
import { Button } from "antd";

export const BlogDetail = () => {
  const navigate = useNavigate();

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <div style={{ width: "60%", margin: "72px 0px", textAlign: "left" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            marginBottom: 32,
          }}
        >
          <Button onClick={() => navigate(-1)}>Back to Blogs</Button>
        </div>
        <h1 style={{ textAlign: "center" }}>
          Maximizing Performance: Georgia Tech Football's Utilization of
          Cutting-Edge Tracking Technologies
        </h1>
        <img
          src={blogImage}
          alt="thumbnail"
          style={{ margin: "16px 0px", width: "100%", height: "auto" }}
        />
        <h6>Photo by Rich von Biberstein/Icon Sportswire via Getty Images</h6>
        <p style={{ fontSize: 16 }}>
          In the realm of modern sports, technology has become an indispensable
          tool for teams and athletes striving for peak performance. The Georgia
          Institute of Technology, renowned for its excellence in academics and
          athletics, is no exception. Their football program has been at the
          forefront of integrating advanced performance tracking technologies to
          optimize player performance and enhance team strategies.
        </p>
        <h3>The Rise of Performance Tracking Technologies</h3>
        <p style={{ fontSize: 16 }}>
          In recent years, the sports industry has witnessed an explosion in
          performance tracking technologies. These innovations provide teams
          with real-time data and insights into player movements, biometrics,
          and game dynamics. This information enables coaches and athletes to
          make data-driven decisions that can significantly impact training
          regimes, game strategies, and injury prevention.
        </p>
        <h5>1. GPS Tracking</h5>
        <p style={{ fontSize: 16 }}>
          Georgia Tech football has adopted Catapult technology to monitor and
          analyze various metrics, such as player speed, acceleration,
          deceleration, and distance covered. Their wearable technology provides
          data related to an athlete's physical exertion, workload, and movement
          patterns during training and games.
        </p>
        <p style={{ fontSize: 16 }}>
          Catapult's GPS and accelerometer-equipped vests worn by players enable
          the coaching staff to assess individual and team performance.
        </p>
        <h5>2. Force Plates</h5>
        <p style={{ fontSize: 16 }}>
          Sparta Science is another revolutionary technology utilized by Georgia
          Tech football. This system provides insights into an athlete's
          movement quality and biomechanics, allowing coaches to evaluate an
          athlete's jump height, power and explosiveness. The Sparta Science
          system employs force plates to capture and analyze movement data. By
          using this data, Georgia Tech's coaching staff can identify areas for
          improvement in technique and mechanics, reducing the risk of injury
          and enhancing performance through better movement patterns. The
          integration of Sparta underscores Georgia Tech's commitment to
          utilizing cutting-edge technologies for precise athlete assessment and
          development.
        </p>
        <h5>3. Velocity Based Training</h5>
        <p style={{ fontSize: 16 }}>
          Perch is a velocity-based training system that measures barbell speed
          and power output during power-lifting and weightlifting variations.
          This real-time feedback allows coaches to adjust training loads and
          volumes, helping athletes optimize their strength and power gains.
        </p>
        <p style={{ fontSize: 16 }}>
          Georgia Tech football mainly leverages Perch for autoregulation in
          season and barbell velocity to monitor the progress of their strength
          training. By tracking performance metrics like velocity & power the
          coaching staff can tailor training sessions to each player's specific
          needs, promoting efficient and targeted training that translates to
          enhanced performance on the field.
        </p>
        <h3>Bringing it All Together - GPS DataViz</h3>
        <p style={{ fontSize: 16 }}>
          The integration of these performance tracking technologies at Georgia
          Tech football exemplifies the ongoing evolution of sports science and
          technology. Until now, these technologies were used in silos,
          independently of each other. By leveraging{" "}
          <a
            href="http://www.gpsdataviz.com"
            target="_blank"
            style={{ textDecoration: "underline" }}
          >
            GPS DataViz’s Automated Insights Platform
          </a>
          , the coaching staff can gain deep insights into player performance,
          tailor training programs, reduce the risk of injuries, and ultimately
          optimize team success on the field.
        </p>
        <p style={{ fontSize: 16 }}>
          Using machine learning, Georgia Tech is able to automate detailed
          performance reports analyzing every player, position group and
          practice period in less than 3 minutes.
        </p>
        <img
          src={cardImage}
          alt="cards"
          style={{ width: "100%", height: "auto", margin: "16px 0px" }}
        />
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={jordanImage}
            style={{ width: "20%", marginRight: "32px" }}
          />
          <p style={{ fontSize: 16 }}>
            <i>
              "GPS Dataviz has been an asset to us through training camp and
              into our season. Working with them has allowed us to better view
              our data and place it in a centralized platform. Doing so has
              allowed us to see things from a different view and improved the
              way we use our technology on a day-to-day basis."
            </i>{" "}
            - <strong>Jordan Diaz</strong>, Director of Speed, Georgia Tech
            Football.
          </p>
        </div>
        <p style={{ fontSize: 16 }}>
          By automating key insights into these reports in mere minutes, the
          Georgia Tech staff is able to spend more time training athletes, using
          GPS Dataviz’s Predictive Analytics tool and building better training
          programs to keep athletes at the peak of their game.
        </p>
        <p style={{ fontSize: 16 }}>
          Looking ahead, the continued integration of cutting-edge technology
          like GPS DataViz will likely become the norm in sports programs aiming
          for excellence. As these technologies advance and become more
          accessible, Georgia Tech and other sports organizations will
          undoubtedly continue to explore innovative ways to leverage data and
          analytics to propel their teams to victory.
        </p>
        <p style={{ fontSize: 16, textAlign: "center" }}>
          Learn more about GPS DataViz here{" "}
          <a href="http://www.gpsdataviz.com" target="_blank">
            www.gpsdataviz.com
          </a>
        </p>
        <div style={{ textAlign: "center" }}>
          <img
            src={COMPANY_LOGO}
            style={{ width: "40%", height: "auto", margin: "16px 0px" }}
          />
        </div>
      </div>
    </div>
  );
};
